import React from "react";

const MAGAZINE_COPY = {
  pt: "Quer ainda mais francês? O magazine Solte seu francês reúne mais de 200 artigos grátis, com exercícios, música e cultura francesa:",
  en: "Want even more French? The Solte seu francês magazine gathers over 200 free articles, with exercises, music and French culture:",
  fr: "Encore plus de français ? Le magazine Solte seu francês réunit plus de 200 articles gratuits, avec exercices, musique et culture française :",
};

export const MagazineBanner = ({ lang, testId }) => (
  <p
    data-testid={testId}
    className="mt-10 max-w-3xl rounded-2xl border border-[#e5e3db] bg-white px-6 py-5 text-sm sm:text-base text-[#3a3a3a] leading-relaxed"
  >
    {MAGAZINE_COPY[lang] || MAGAZINE_COPY.pt}{" "}
    <a
      href="https://www.solteseufrances.com.br"
      target="_blank"
      rel="noopener"
      data-testid={`${testId}-link`}
      className="font-medium text-[#d9381e] link-underline"
    >
      www.solteseufrances.com.br
    </a>
  </p>
);

const VERBOS_COPY = {
  pt: ["Travando nos verbos? Conjugue qualquer verbo francês de graça no", "."],
  en: ["Stuck on verbs? Conjugate any French verb for free on", "."],
  fr: ["Bloqué sur les verbes ? Conjuguez n'importe quel verbe français gratuitement sur", "."],
};

export const VerbosBanner = ({ lang, testId }) => {
  const [before, after] = VERBOS_COPY[lang] || VERBOS_COPY.pt;
  return (
    <p
      data-testid={testId}
      className="mt-10 max-w-3xl rounded-2xl border border-[#e5e3db] bg-white px-6 py-5 text-sm sm:text-base text-[#3a3a3a] leading-relaxed"
    >
      {before}{" "}
      <a
        href="https://solteseusverbos.com.br"
        target="_blank"
        rel="noopener"
        data-testid={`${testId}-link`}
        className="font-medium text-[#d9381e] link-underline"
      >
        SolteSeusVerbos+
      </a>
      {after}
    </p>
  );
};